<div class="sidebar-footer-wrapper my-6">
    <div *ngIf="user" class="flex align-items-center justify-content-center">
        <p-toast></p-toast>
        <p-menu
            #menu
            [model]="items"
            [popup]="true"
            appendTo="body"
            [style]="{'margin-bottom':'20px', 'z-index': '9999 !important'}"
        />

        <p-avatar *ngIf="!user.photo" icon="pi pi-user" size="large" styleClass="mr-2" shape="circle" />
        <p-avatar
            *ngIf="user.photo"
            [image]="user.photo"
            size="large"
            styleClass="cursor-pointer mr-2"
            shape="circle"
        />

        <div class="flex flex-row justify-content-center cursor-pointer" (click)="menu.toggle($event)">
            <div class="flex flex-column gap-1">
                <div class="name-surname"><h4>{{ user.firstName }} {{ user.lastName }}</h4></div>
                <div class="email text-sm"><h6>{{ user.email }}</h6></div>
            </div>
            <div class="flex justify-content-center align-items-center">
                <i class="pi pi-chevron-down"></i>
            </div>
        </div>
    </div>
</div>
